import { BLOCKQUOTE_NODE } from "@repo/fika-blog/src/nodes/blockquoteNode"
import { IMAGE_NODE } from "@repo/fika-blog/src/nodes/imageNode"
import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import { NodeSelection } from "@repo/fika-blog/src/tiptap/pm/state"
import { Match, Show, Switch } from "solid-js"
import { createEditorTransaction } from "solid-tiptap"
import { BlockquoteMenu } from "./blockquoteMenu"
import { CodeMenu } from "./codeMenu"
import { HeadingMenu } from "./headingMenu"
import { ImageMenu } from "./imageMenu"
import { ListItemMenu } from "./listItemMenu"
import { ListMenu } from "./listMenu"
import { ParagraphMenu } from "./paragraphMenu"
import { TextMenu } from "./textMenu"

type Props = {
  editor?: Editor
}
export function PanelMenu(props: Props) {
  const nodeType = createEditorTransaction(
    () => props.editor,
    editor => {
      if (!editor) return null

      const { state } = editor
      const { selection } = state

      if (selection instanceof NodeSelection) {
        return selection.node.type.name
      }

      return null
    },
  )

  return (
    <Show when={props.editor}>
      {editor => (
        <Switch>
          <Match when={!nodeType()}>
            <TextMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === "paragraph"}>
            <ParagraphMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === "heading"}>
            <HeadingMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === "codeBlock"}>
            <CodeMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === "listItem"}>
            <ListItemMenu editor={editor()} />
          </Match>
          <Match
            when={nodeType() === "bulletList" || nodeType() === "orderedList"}
          >
            <ListMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === IMAGE_NODE}>
            <ImageMenu editor={editor()} />
          </Match>
          <Match when={nodeType() === BLOCKQUOTE_NODE}>
            <BlockquoteMenu editor={editor()} />
          </Match>
        </Switch>
      )}
    </Show>
  )
}
